import { screenSizes } from '@lux/tokens';
import { useWindowWidth } from '@lux/hooks';
export function useIsSmallDevice() {
    const windowWidth = useWindowWidth();
    return !windowWidth || windowWidth < screenSizes.sm;
}
//# sourceMappingURL=useIsSmallDevice.js.map